module.exports = __webpack_public_path__ + "static/media/GEOSaison.72d877af.webp";